var map = {
	"./appauth/group-pages/groups.module": [
		"./src/app/appauth/group-pages/groups.module.ts"
	],
	"./appauth/user-pages/users.module": [
		"./src/app/appauth/user-pages/users.module.ts",
		"appauth-user-pages-users-module"
	],
	"./appmantenimiento/reparar-asignaciones/asignaciones.module": [
		"./src/app/appmantenimiento/reparar-asignaciones/asignaciones.module.ts",
		"appmantenimiento-reparar-asignaciones-asignaciones-module~appmantenimiento-reparar-recepciones-recep~9a1c94c5",
		"appmantenimiento-reparar-asignaciones-asignaciones-module~appmantenimiento-reparar-recepciones-recep~b29c083b",
		"appmantenimiento-reparar-asignaciones-asignaciones-module"
	],
	"./appmantenimiento/reparar-clientes/clientes.module": [
		"./src/app/appmantenimiento/reparar-clientes/clientes.module.ts"
	],
	"./appmantenimiento/reparar-dispositivos/dispositivos.module": [
		"./src/app/appmantenimiento/reparar-dispositivos/dispositivos.module.ts",
		"appmantenimiento-reparar-dispositivos-dispositivos-module"
	],
	"./appmantenimiento/reparar-marcas/marcas.module": [
		"./src/app/appmantenimiento/reparar-marcas/marcas.module.ts",
		"appmantenimiento-reparar-marcas-marcas-module"
	],
	"./appmantenimiento/reparar-modelos/modelos.module": [
		"./src/app/appmantenimiento/reparar-modelos/modelos.module.ts",
		"appmantenimiento-reparar-modelos-modelos-module"
	],
	"./appmantenimiento/reparar-recepciones/recepciones.module": [
		"./src/app/appmantenimiento/reparar-recepciones/recepciones.module.ts",
		"appmantenimiento-reparar-asignaciones-asignaciones-module~appmantenimiento-reparar-recepciones-recep~9a1c94c5",
		"appmantenimiento-reparar-asignaciones-asignaciones-module~appmantenimiento-reparar-recepciones-recep~b29c083b",
		"appmantenimiento-reparar-recepciones-recepciones-module"
	],
	"./appmantenimiento/reparar-recepcionistas/recepcionistas.module": [
		"./src/app/appmantenimiento/reparar-recepcionistas/recepcionistas.module.ts"
	],
	"./appmantenimiento/reparar-reportes/reportes.module": [
		"./src/app/appmantenimiento/reparar-reportes/reportes.module.ts"
	],
	"./appmantenimiento/reparar-tecnicos/tecnicos.module": [
		"./src/app/appmantenimiento/reparar-tecnicos/tecnicos.module.ts",
		"appmantenimiento-reparar-asignaciones-asignaciones-module~appmantenimiento-reparar-recepciones-recep~9a1c94c5"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"dashboard-dashboard-module"
	],
	"./error/error.module": [
		"./src/app/error/error.module.ts",
		"error-error-module"
	],
	"./session/session.module": [
		"./src/app/session/session.module.ts",
		"session-session-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;